import { PostScheduleStatus, PageData, GroupData } from 'src/pages/Facebook/components/types';
import { Job } from './Job.type';

export interface FacebookPostRotation {
  id: string;
  postText: string;
  postPictureUrl: string;
  postOrder: number;
}

export type PostSchedule = {
  jobId: string;
  name: string;
  city: string;
  startTime: string;
  startDate: string;
  endDate: string;
  frequency: PostFrequency;
  postType: PostType;
  status: PostScheduleStatus;
  pageData: PageData[];
  groupData: GroupData[];
  facebookPosts: FacebookPostRotation[];
};

export interface FacebookPost {
  id: string;
  postText?: string;
  postPictureUrl?: string;
  job?: Job;
  status: PostStatus;
}

export enum PostStatus {
  PENDING = 'Pending',
  POSTED = 'Posted',
  REJECTED = 'Rejected',
}

export enum PostFrequency {
  DAILY = 'Daily',
  EVERY_SECOND_DAY = 'Every second day',
  WEEKLY = 'Weekly',
}

export enum PostType {
  SHARE = 'Share',
  POST = 'Post',
}

export enum PageOptions {
  DELLA_DIAKMUNKA = 'Della - Diákmunka könnyedén',
}

export enum GroupOptions {
  DIAKMUNKA_BUDAPEST = 'Diákmunka / Student Work Budapest',
  DIAKMUNKA_DEBRECEN = 'Diákmunka / Student Work Debrecen',
  DIAKMUNKA_GYOR = 'Diákmunka Győr / Student Work Győr',
  DIAKMUNKA_PECS = 'Diákmunka Pécs / Student Work Pécs',
  DIAKMUNKA_NYIREGYHAZA = 'Diákmunka Nyíregyháza / Student Work Nyíregyháza',
  DIAKMUNKA_SZEGED = 'Diákmunka Szeged / Student Work Szeged',
  DIAKMUNKA_MISKOLC = 'Diákmunka Miskolc / Student Work Miskolc',
  DIAKMUNKA_BALATON = 'Diákmunka Balaton / Student Work Balaton',
  DIAKMUNKA_SOPRON = 'Diákmunka Sopron / Student Work Sopron',
  DIAKMUNKA_INFORMATIKA = 'Diákmunka / Gyakornoki munkák-informatikai országos',
  DIAKMUNKA_KOZGAZDASZ = 'Diákmunka / Gyakornoki munkák-közgazdász országos',
  DIAKMUNKA_FESZTIVALOKON = 'Diákmunka Fesztiválokon / Student Work at Festivals',
}
